<template>
  <div>
    <b>Grafica:</b>
    <el-radio-group
      v-model="distribution_type_selected"
      @change="generateChart">
      <el-radio label="weight">Tipo Peso</el-radio>
      <el-radio label="zone">Tipo Zona</el-radio>
    </el-radio-group>

    <el-select
      style="margin-left: 20px;"
      v-if="distribution_type_selected == 'zone'"
      v-model="distribution_zone_selected"
      placeholder="Seleccionar"
      size="mini"
      @change="generateChart">
      <el-option v-for="type in options_zones"
        :key="type.value"
        :label="type.label"
        :value="type.value">
      </el-option>
    </el-select>
    <div class="svg"></div>
  </div>
</template>
<script>
import d3 from '@/utils/chart';

const COLOR_CHART = [
  '#7d58ff', '#157ff2', '#eb293a', '#14c684',
  '#ff007d', '#20d5ff', '#5e72e4', '#2dce89',
  '#f5365c', '#fb6340', '#11cdef', '#7d58ff',
  '#172b4d', '#eb293a', '#ff007d', '#8898aa',
];

export default {
  props: {
    rules: Array,
  },
  data() {
    return {
      distribution_type_selected: 'weight',
      distribution_zone_selected: 1,
      options_zones: [
        {
          value: 1,
          label: 'Zona 1',
        },
        {
          value: 2,
          label: 'Zona 2',
        },
        {
          value: 3,
          label: 'Zona 3',
        },
        {
          value: 4,
          label: 'Zona 4',
        },
        {
          value: 5,
          label: 'Zona 5',
        },
        {
          value: 6,
          label: 'Zona 6',
        },
        {
          value: 7,
          label: 'Zona 7',
        },
        {
          value: 8,
          label: 'Zona 8',
        },
      ],
      chart: null,
    };
  },
  watch: {
    rules() {
      this.generateChart();
    },
  },
  created() {
    this.generateChart();
  },
  methods: {
    generateChart() {
      const taskname = {};
      let index = 0;
      const parent = new Set();
      const tasks = [];

      this.rules.forEach((rule) => {
        if (rule.clients.length) return;
        if (!rule.rules) return;

        if (!rule.enable || rule.environment !== 'production') return;

        taskname[rule.name] = COLOR_CHART[index++];

        parent.add(rule.rules.code);

        if (rule.rules.type === 'weight'
          && rule.rules.type === this.distribution_type_selected) {
          const ranges = rule.rules.configuration.map(({ range }) => range);
          // eslint-disable-next-line no-restricted-syntax
          for (const range of ranges) {
            tasks.push({
              start: range[0],
              end: range[1],
              parent: rule.rules.code,
              name: rule.name,
            });
          }
        }

        if (rule.rules.type === 'zone'
          && rule.rules.type === this.distribution_type_selected) {
          // eslint-disable-next-line no-restricted-syntax
          for (const { zone, ...params } of rule.rules.configuration) {
            const ranges = params.ranges.map(({ range }) => range);
            if (this.distribution_zone_selected === zone) {
              // eslint-disable-next-line no-restricted-syntax
              for (const range of ranges) {
                tasks.push({
                  start: range[0],
                  end: range[1],
                  parent: rule.rules.code,
                  name: rule.rules.name,
                });
              }
            }
          }
        }
      });

      const parents = [...parent];

      if (this.chart) {
        d3
          .selectAll('svg')
          .remove();
      }

      this.chart = d3
        .gantt()
        .taskTypes(parents)
        .taskname(taskname);

      this.chart(tasks);
    },
  },
};
</script>

<style scoped>

.svg {
  font-family: Arial, sans-serif;
  font-size: 12px;
  text-align: center;
  padding: 20px;
  background-color: #8969fe0d;
  margin: 10px 0px;
  border-radius: 4px;
}
</style>
